import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { baseurl } from "../utility/helper";
import "../assets/css/JoinUs.css";
import "../assets/css/BatchPage.css";

dayjs.extend(advancedFormat);

// Public landing page for an institute batch (/batch/:batchCode, the link copied
// from the admin Batch Dashboard). Lists the batch's Active tests; registering
// hands over to the existing institute registration page (InsViewTest), which
// needs the test id and whether the candidate is a student or a teacher.

const BatchPage = () => {
  const { batchCode } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${baseurl}/batch/${encodeURIComponent(batchCode)}`)
      .then((r) => { setData(r.data); setError(""); })
      .catch((err) => {
        setData(null);
        setError(err.response?.status === 404 ? "We couldn't find this batch. Please check the link." : "Something went wrong. Please try again later.");
      })
      .finally(() => setLoading(false));
  }, [batchCode]);

  const register = (testId, studenttype) =>
    navigate(`/InsViewTest?testId=${testId}&studenttype=${studenttype}`);

  const registrationState = (t) => {
    const now = dayjs();
    if (t.register_start_date && now.isBefore(dayjs(t.register_start_date))) return "Registration not open yet";
    if (t.register_end_date && now.isAfter(dayjs(t.register_end_date))) return "Registration closed";
    if (t.seat && t.registered_count >= t.seat) return "Seats full";
    return "";
  };

  if (loading) {
    return <div className="batch-page"><div className="container"><p className="batch-msg">Loading…</p></div></div>;
  }
  if (error) {
    return <div className="batch-page"><div className="container"><p className="batch-msg">{error}</p></div></div>;
  }

  const { batch, tests } = data;

  return (
    <div className="batch-page">
      <div className="container">
        <div className="batch-head">
          <h1>{batch.institute_name}</h1>
          {batch.institute_location && <div className="batch-sub">{batch.institute_location}</div>}
          <div className="batch-name">
            {batch.batch_name} <span>({batch.batch_code})</span>
          </div>
        </div>

        {batch.status !== "Active" ? (
          <p className="batch-msg">This batch is not open for registration.</p>
        ) : tests.length === 0 ? (
          <p className="batch-msg">No tests are open for registration in this batch yet. Please check back later.</p>
        ) : (
          <div className="row">
            {tests.map((t) => {
              const blocked = registrationState(t);
              const icon = (
                <span className="uim-svg" style={{ display: "inline-block" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em">
                    <rect width="20" height="15" x="2" y="3" className="uim-tertiary" rx="3"></rect>
                    <path
                      className="uim-primary"
                      d="M16,21H8a.99992.99992,0,0,1-.832-1.55469l4-6a1.03785,1.03785,0,0,1,1.66406,0l4,6A.99992.99992,0,0,1,16,21Z"
                    ></path>
                  </svg>
                </span>
              );
              return (
                <div key={t.test_id} className="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                  <div className="card service-wrapper rounded border-0 shadow p-4" style={{ minHeight: "350px" }}>
                    <div className="icon text-center text-custom h1 shadow rounded bg-white">{icon}</div>
                    <div className="content">
                      <h5 className="title">{t.test_title}</h5>
                      <br />
                      <h1 className="startdate">{t.test_start_time ? dayjs(t.test_start_time).format("dddd, Do MMMM, YYYY") : "—"}</h1>
                      <p className="text-muted mt-3 mb-0">
                        <b>{t.test_desc}</b> <br />
                        <span className="venue-text">{t.venue}</span>
                      </p>
                      {blocked ? (
                        <div className="batch-blocked mt-3">{blocked}</div>
                      ) : (
                        <div className="batch-actions mt-3">
                          <button className="btn btn-outline-primary w-100" onClick={() => register(t.test_id, "institutestudent")}>
                            Know More
                          </button>
                        </div>
                      )}
                      <div className="big-icon h1 text-custom">{icon}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default BatchPage;
